import colors from '../colors';

export default {
  MuiAccordionDetails: {
    root: {
      padding: 0,
      display: 'block',
      color: colors.black,
    },
  },
};
